import { useDeletionRequest } from './deletionRequestStore';
import { useDeletionJob } from './useDeletionJob';
export function useLocalDeletionBlocker(): boolean {
  const stored = useDeletionRequest();
  const query = useDeletionJob(stored.request);
  if (stored.storageFailed) return true;
  if (!stored.request) return false;
  if (!query.isSuccess) return true;
  return query.data.status !== 'succeeded' && query.data.status !== 'failed';
}
